import { render } from "./itemCalculate.vue?vue&type=template&id=1187a090&scoped=true"
import script from "./itemCalculate.vue?vue&type=script&lang=js"
export * from "./itemCalculate.vue?vue&type=script&lang=js"

import "./itemCalculate.vue?vue&type=style&index=0&id=1187a090&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1187a090"]])

export default __exports__